import React from 'react';
import { Avatar, Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Modal } from '../Modals';
const AVATAR_IMAGE_SIZE = '56px';
const FlexContainer = styled.div `
    display: flex;
    margin-bottom: 1rem;
`;
const InfoContainer = styled.div `
    margin-left: 1rem;
    margin-top: 0.5rem;
`;
const Container = styled.div `
    margin-top: 1.5rem;
`;
const Content = styled.div `
    max-height: 725px;
    overflow: auto;
`;
const StyledAdditionalInfo = styled(Typography) `
    color: ${(props) => props.theme.colors.textSecondary};
`;
export const AuthorsModal = ({ authorDetails, open, title, onClose, avatarSize }) => {
    return (React.createElement(Container, null,
        React.createElement(Modal, { open: open, onClose: onClose, modalTitle: title ? title : 'Authors', labelProps: { 'aria-label': 'Skill authors modal' }, ConfirmButton: () => (React.createElement(Button, { "aria-label": "modal done button", color: "primary", variant: "contained", onClick: onClose, disableElevation: true }, "Done")), CancelButton: () => null },
            React.createElement(Content, null, authorDetails.map((author, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                return (React.createElement(FlexContainer, { key: index },
                    React.createElement(Avatar, { key: index, alt: (_c = (_b = (_a = author.name) === null || _a === void 0 ? void 0 : _a.first) !== null && _b !== void 0 ? _b : author.alias) !== null && _c !== void 0 ? _c : '', src: (_d = author.imageUrl) !== null && _d !== void 0 ? _d : '', style: {
                            width: avatarSize ? avatarSize : AVATAR_IMAGE_SIZE,
                            height: avatarSize ? avatarSize : AVATAR_IMAGE_SIZE
                        }, title: author.alias ? author.alias : ((_e = author.name) === null || _e === void 0 ? void 0 : _e.first) ? author.name.first : '' }),
                    React.createElement(InfoContainer, null,
                        React.createElement("strong", null, (_h = (_g = (_f = author.name) === null || _f === void 0 ? void 0 : _f.first) !== null && _g !== void 0 ? _g : author.alias) !== null && _h !== void 0 ? _h : '',
                            " ", (_k = (_j = author.name) === null || _j === void 0 ? void 0 : _j.last) !== null && _k !== void 0 ? _k : '',
                            React.createElement(StyledAdditionalInfo, { variant: 'subtitle2' }, (_l = author.aboutInfo) !== null && _l !== void 0 ? _l : '')))));
            })))));
};
//# sourceMappingURL=AuthorsModal.js.map